import { DateTime, Interval } from "luxon"

interface Args {
  startingMonth?: string | null
  terminationDate?: string | null
}

export const getEndingMonthOptions = ({ startingMonth, terminationDate }: Args) => {
  if (!startingMonth) return []

  const terminationDateInstance = terminationDate
    ? DateTime.fromISO(terminationDate).endOf("month")
    : null

  const startDateInstance = DateTime.fromISO(startingMonth).startOf("month").plus({ months: 1 })
  let endDateInstance = startDateInstance.plus({ months: 11 })
  if (terminationDateInstance && endDateInstance > terminationDateInstance) {
    endDateInstance = terminationDateInstance
  }

  return Interval.fromDateTimes(startDateInstance, endDateInstance)
    .splitBy({ month: 1 })
    .map(({ start: current }) => ({
      value: `${current.year}-${current.month.toString().padStart(2, "0")}`,
      label: current.toLocaleString({ month: "long", year: "numeric" }),
    }))
}
